import { IconButton, Panel } from '@epam/loveship'
import { cx } from '@epam/uui-core'
import { ReactComponent as navigationLeft } from '@epam/assets/icons/common/navigation-chevron-left-24.svg'
import { useAppSelector } from '../../hooks/redux/redux'
import { useIsFirstSidebarMount } from '../../hooks/useIsFirstSidebarMount'
import { useSideBarControlls } from '../../hooks/useSideBarControlls'
import { EditPointForm } from '../../pages/main/components/EditPointForm/EditPointForm'
import { LocEventPanel } from '../../pages/main/components/PointAndEventPanel/PointAndEventPanel'
import { LocationInfo } from '../../pages/main/components/LocationInfo/LocationInfo'
import { NewPointForm } from '../../pages/main/components/NewPointForm/NewPointForm'
import { PointInfo } from '../../pages/main/components/PointInfo/PointInfo'
import css from './SidebarPanel.module.scss'

export const SidebarPanel = () => {
  const { selectedPoint } = useAppSelector((state) => state.points)
  const { selectedLocation } = useAppSelector((state) => state.locations)
  const {
    isSideBarOpened,
    isSideBarGoingToClose,
    isNewPointFormOpened,
    isEditPointFormOpened,
    isPointAndEventPanelOpen,
    isPointInfoOpened,
    isLocationInfoOpened,
  } = useAppSelector((state) => state.app)
  const { setSideBarClosingInitiated, showEventsPanel } = useSideBarControlls()
  const isFirstMount = useIsFirstSidebarMount(isSideBarOpened)

  const className = cx(
    css.infoSidebarPanelWrapper,
    { show: isSideBarOpened && !isFirstMount },
    { hide: isSideBarGoingToClose && !isFirstMount }
  )

  return (
    <div className={className}>
      <Panel
        cx={css.panelWrapper}
        background="white"
        style={{ overflow: 'auto' }}
      >
        {isNewPointFormOpened && <NewPointForm />}
        {isPointAndEventPanelOpen && <LocEventPanel />}
        {selectedPoint && isEditPointFormOpened && (
          <EditPointForm point={selectedPoint} />
        )}
        {selectedPoint && isPointInfoOpened && (
          <PointInfo pointId={selectedPoint.id} />
        )}
        {selectedLocation && isLocationInfoOpened && (
          <LocationInfo selectedLocation={selectedLocation} />
        )}
      </Panel>
      <IconButton
        cx={css.closeSidebarBtn}
        icon={navigationLeft}
        onClick={
          isSideBarOpened
            ? () => setSideBarClosingInitiated(true)
            : () => showEventsPanel()
        }
      />
    </div>
  )
}
